import { render, staticRenderFns } from "./UpdateDetailPage.vue?vue&type=template&id=25bfdf86&scoped=true&"
import script from "./UpdateDetailPage.vue?vue&type=script&lang=js&"
export * from "./UpdateDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDetailPage.vue?vue&type=style&index=0&id=25bfdf86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfdf86",
  null
  
)

export default component.exports